export class UsuarioFormModel {
    constructor(
        public id: string = "",
        public nome: string = "",
        public email: string = "",
        public imagem: string = "",
        public apelido: string = "",
        public telefone: string = ""
    ) { }
}